<script>
    export let tag;
    import { Router, Link, Route } from "svelte-routing";
    import Fa from 'svelte-fa'
    import { faFlag } from '@fortawesome/free-solid-svg-icons'

    function tagColor(tag){
        if (tag == "Modeling"){
            return "blue"
        }
        if (tag == "Experiments"){
            return "orange"
        }
        if (tag == "Clinics"){
            return "green"
        }
        if (tag == "Data integration"){
            return "red"
        }
    }
</script>
<style></style>


<Link to="/{tag.toLowerCase().replace(" ", "")}">
    <div class="chip {tagColor(tag)}">
        {tag}
    </div>
</Link>

